import { default as smartshare } from './smartshare/routes'
import { default as integration } from './integration/routes'
import { default as azureAd } from './azure-ad/routes'

export default [
    ...smartshare,
    ...integration,
    ...azureAd
]